export const ViewIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99 3.5c-2.436 0-4.935 1.41-6.902 4.23a.5.5 0 00-.008.554C2.591 10.65 5.056 12.5 7.99 12.5c2.9 0 5.416-1.856 6.93-4.227a.504.504 0 000-.545C13.403 5.383 10.87 3.5 7.99 3.5z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
